import copy from 'copy-to-clipboard';
import { useToast } from 'hooks/useToast';

const useCopyToClipboard = (value: string, extraData = 'copiado para área de transferência!') => {
  const Toast = useToast();

  const handleCopy = (dataToCopy: string) => {
    try {
      copy(dataToCopy);
      Toast.addToast({ heading: `${value} ${extraData}`, type: 'success' });
    } catch (error) {
      Toast.addToast({
        heading: `Não foi possível copiar ${value.toLowerCase()}, por favor tente novamente.`,
        type: 'error',
      });
    }
  };
  return [handleCopy];
};

export { useCopyToClipboard };
